import React from 'react';
import { Header } from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 lg:max-w-[90%]">
        {children}
      </main>
    </div>
  );
};
